define("shared/components/shared/address-fields/country", ["exports", "@ember/component", "@ember/object", "@ember/service", "@ember/utils", "@glimmer/component", "later/utils/constants", "shared/utils/country-list", "@ember/template-factory"], function (_exports, _component, _object, _service, _utils, _component2, _constants, _countryList, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@ember/utils",0,"@glimmer/component",0,"later/utils/constants",0,"shared/utils/country-list",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <PowerSelect
    @disabled={{@isDisabled}}
    @dropdownClass="qa--address_country__list"
    @onChange={{this.updateSelectedCountry}}
    @options={{this.sortedCountryList}}
    @placeholder={{t "account.subscription.billing.address.country"}}
    @renderInPlace={{true}}
    @searchEnabled={{true}}
    @searchField="name"
    @searchPlaceholder={{t "shared_words.search"}}
    @selected={{this.selectedCountry}}
    @triggerClass="qa--address_country__dropdown"
    class={{if (or this.showEmptyError (is-present this.suggestion)) "ember-basic-dropdown--hasError"}}
    data-test-id="country-select"
    {{on "click" this.addSearchClass}}
    as |country|
  >
    <span class="qa--country_list_dropdown" data-test-code={{country.code}} data-test-id="country-option">
      {{country.name}}
    </span>
  </PowerSelect>
  <Shared::AddressFields::Error
    @emptyText={{t "errors.address.empty.country"}}
    @field={{@field}}
    @missingValue={{this.showEmptyError}}
    @suggestion={{this.suggestion}}
  />
  */
  {
    "id": "2M/J7X+R",
    "block": "[[[8,[39,0],[[16,0,[52,[28,[37,2],[[30,0,[\"showEmptyError\"]],[28,[37,3],[[30,0,[\"suggestion\"]]],null]],null],\"ember-basic-dropdown--hasError\"]],[24,\"data-test-id\",\"country-select\"],[4,[38,5],[\"click\",[30,0,[\"addSearchClass\"]]],null]],[[\"@disabled\",\"@dropdownClass\",\"@onChange\",\"@options\",\"@placeholder\",\"@renderInPlace\",\"@searchEnabled\",\"@searchField\",\"@searchPlaceholder\",\"@selected\",\"@triggerClass\"],[[30,1],\"qa--address_country__list\",[30,0,[\"updateSelectedCountry\"]],[30,0,[\"sortedCountryList\"]],[28,[37,4],[\"account.subscription.billing.address.country\"],null],true,true,\"name\",[28,[37,4],[\"shared_words.search\"],null],[30,0,[\"selectedCountry\"]],\"qa--address_country__dropdown\"]],[[\"default\"],[[[[1,\"\\n  \"],[10,1],[14,0,\"qa--country_list_dropdown\"],[15,\"data-test-code\",[30,2,[\"code\"]]],[14,\"data-test-id\",\"country-option\"],[12],[1,\"\\n    \"],[1,[30,2,[\"name\"]]],[1,\"\\n  \"],[13],[1,\"\\n\"]],[2]]]]],[1,\"\\n\"],[8,[39,6],null,[[\"@emptyText\",\"@field\",\"@missingValue\",\"@suggestion\"],[[28,[37,4],[\"errors.address.empty.country\"],null],[30,3],[30,0,[\"showEmptyError\"]],[30,0,[\"suggestion\"]]]],null]],[\"@isDisabled\",\"country\",\"@field\"],false,[\"power-select\",\"if\",\"or\",\"is-present\",\"t\",\"on\",\"shared/address-fields/error\"]]",
    "moduleName": "shared/components/shared/address-fields/country.hbs",
    "isStrictMode": false
  });
  let CountryComponent = _exports.default = (_class = class CountryComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "address", _descriptor, this);
      _initializerDefineProperty(this, "intl", _descriptor2, this);
      _defineProperty(this, "countryList", (0, _countryList.default)(this.intl).filter(country => _constants.ADDRESS_COUNTRIES_SUPPORTED_BY_SMARTY.includes(country.code)));
    }
    get sortedCountryList() {
      if (!this.args.sortCommonCountriesFirst) {
        return this.countryList;
      }
      return this.countryList.sort((a, b) => {
        const priorityOrder = _constants.COMMON_COUNTRIES_PRIORITIZED;
        const aIndex = priorityOrder.indexOf(a.code);
        const bIndex = priorityOrder.indexOf(b.code);
        if (aIndex === -1 && bIndex === -1) {
          return 0;
        }

        // If only one is priority, priority country comes first
        if (bIndex === -1) return -1;
        if (aIndex === -1) return 1;
        return aIndex - bIndex;
      });
    }
    get showEmptyError() {
      return this.args.showErrors && !(0, _utils.isPresent)(this.selectedCountry);
    }
    get selectedCountry() {
      return this.countryList.find(country => country.code === this.args.country) || undefined;
    }
    get suggestion() {
      return this.args.suggestions.find(item => item.key === this.args.field);
    }
    addSearchClass() {
      const search = document.getElementsByClassName('ember-power-select-search-input');
      search[0]?.classList.add('qa--address_country__input');
    }
    updateSelectedCountry(_ref) {
      let {
        code
      } = _ref;
      this.address.resetValidation();
      this.args.setSelectedCountry(code);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "address", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "addSearchClass", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "addSearchClass"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateSelectedCountry", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateSelectedCountry"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, CountryComponent);
});